import { render, staticRenderFns } from "./ServicesFour.vue?vue&type=template&id=4b33b851&"
import script from "./ServicesFour.vue?vue&type=script&lang=js&"
export * from "./ServicesFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports